export default __webpack_public_path__ + "static/media/arrow-down.80a274c3.svg";